import MaterialUiCheckBox from '@material-ui/core/Checkbox';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import CheckedIcon from '../../../assets/checkedIcon.svg';
import Icon from '../../../assets/icon.svg';
import { useHomeGamesWidget } from '../../../model';

import styles from './SelectGame.scss';

interface Props {
  id: string;
  listView?: boolean;
}

const SelectGame: React.FC<Props> = ({ id, listView }) => {
  const { widgetSelect, widgetDispatch } = useHomeGamesWidget();
  const selectedGames = useSelector(widgetSelect.selectedGames);

  const handleChange = (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    widgetDispatch.gameSelect({ gameId: id, select: checked });
  };

  return (
    <div
      className={classNames(styles.checkboxContainer, 'select-game', {
        [styles.listView]: listView
      })}
      onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
    >
      <MaterialUiCheckBox
        disableRipple
        classes={{ root: styles.checkbox, checked: styles.checked }}
        onChange={handleChange}
        checked={selectedGames?.[0] === id}
        icon={<Icon />}
        checkedIcon={<CheckedIcon />}
      />
    </div>
  );
};

export default SelectGame;
